export const VARIABLES_ENCRYPT_KEY = 'Variables';
